import { CASES } from './constants';

/**
 * Action to update comments in the store.
 *
 * This action is dispatched to update the comments state in the Redux store.
 * It takes a payload containing the new comments' data.
 *
 * @param {Object} payload - The new comments data to be stored.
 * @returns {Object} The action object with type and payload.
 **/
export const updateComments = (payload) => {
    return { type: CASES.UPDATE_COMMENTS, payload };
};

/**
 * Action to update the comments filter form.
 *
 * This action is dispatched to update the filter form state in the Redux store.
 * It takes a key and data to update the specific field in the filter form.
 *
 * @param {string} key - The key of the filter form field to be updated.
 * @param {any} data - The new data to be set for the specified field.
 * @returns {Object} The action object with type and payload.
 **/
export const updateCommentsFilterForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_COMMENTS_FILTER_FORM,
        payload: { key, data },
    };
};

/**
 * Action to clear the comments filter form.
 *
 * This action is dispatched to reset the filter form state in the Redux store.
 * It clears all the fields in the filter form.
 *
 * @returns {Object} The action object with type and payload.
 **/
export const clearComments = () => {
    return { type: CASES.CLEAR_COMMENTS, payload: {} };
};
